import styled from "@emotion/styled";
import {
  ArrowRight,
  Button,
  Identity,
  Text,
} from "@totalenergiescode/mobility-business-rev-design-system";

import { MemoizedPageHeader as PageHeader } from "@/components/shared/PageHeader/component";

export const StyledContainerDiv = styled("div")({
  display: "flex",
  flexDirection: "column",
});

export const StyledSectionContainerDiv = styled("div")({
  paddingLeft: "34px",
});

export const StyledTitle = styled(Text)({
  padding: "24px 0 24px 34px",
});

export const StyledCardContainerDiv = styled("div")({
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr",
  columnGap: "8px",
  rowGap: "8px",
  padding: "0 68px 34px 34px",
});

export const StyledCardDiv = styled("div")(({ theme }) => ({
  padding: "24px",
  backgroundColor: theme.palette.grey[50],
  borderRadius: "8px",
}));

export const StyledRoundedTopRightCardDiv = styled("div")(({ theme }) => ({
  padding: "24px",
  backgroundColor: theme.palette.grey[50],
  borderRadius: "8px 40px 8px 8px",
}));

export const StyledCardTitle = styled(Text)(({ theme }) => ({
  fontFamily: '"Nunito", sans-serif',
  lineHeight: 1,
  color: theme.palette.grey[500],
  padding: "0 0 16px",
}));

export const StyledCardContent = styled(Text)({
  padding: "16px 0 0",
  fontSize: "14px",
});

export const StyledIdentity = styled(Identity)(({ theme }) => ({
  padding: "16px 0 0",
  ".MuiAvatar-circular": {
    backgroundColor: theme.palette.avatar.lightGreen,
    "*": {
      color: theme.palette.white,
    },
  },
  ".MuiTypography-text1": {
    color: "#86959b",
  },
}));

export const StyledButtonHeaderContainerDiv = styled("div")({
  display: "flex",
  flexDirection: "row",
  gap: "16px",
});

export const StyledPageHeader = styled(PageHeader)({
  justifyContent: "space-between",
  padding: "0 40px 20px",
});

export const StyledButtonNotifications = styled(Button)({
  gap: "2px",
});

export const StyledArrowRight = styled(ArrowRight)(({ theme }) => ({
  color: theme.palette.white,
}));
